export const isCategoryValid = ({ category, listingType }) =>
    category && category.context && category.id && listingType === 'category';

export const getHeaderTitle = ({
    brand,
    category,
    listingType,
    searchQuery,
}) => {
    if (listingType === 'brand') return brand?.name || '';
    /**
     * We may get a query in both search and category page
     * (search page or inCategorySearch page)
     * So we need to check its value before search or category
     * */
    if (searchQuery) return searchQuery.replace(/[+]/g, ' ');
    if (listingType === 'category') return category?.name || '';
    return '';
};

export default {
    isCategoryValid,
    getHeaderTitle,
};
